import React from 'react'
import styled from 'styled-components'
import menuIcon from '../img/menu-open.svg'

import { introGutter, media } from '../utils/style-utils'

const Button = styled.button`
  border: 0;
  border-radius: 0;
  background: none;
  position: fixed;
  cursor: pointer;
  z-index: 99;

  display: flex;
  align-items: center;
  justify-content: center;

  top: 0;
  right: 0;
  width: 60px;
  height: 60px;

  ${media.tablet`
    width: 80px;
    height: 80px;
    top: calc(${introGutter} / 2 - 40px);
    right: calc(${introGutter} / 2 - 40px);
  `};
  &:focus {
    outline: none;
  }

  img {
    display: block;
    flex-grow: 0;
    flex-shrink: 0;
  }
`

const MenuToggle = props => {
  const { onClick } = props
  return (
    <Button onClick={onClick}>
      <img src={menuIcon} alt="Open menu" />
    </Button>
  )
}

export default MenuToggle



// WEBPACK FOOTER //
// ./src/components/MenuToggle.js